import type { MailboxInfo } from "owa-client-types";
import { getMailboxInfo } from "../../selectors/mailRowDataPropertyGetter";
import { isUnifiedInboxMailboxInfo } from "owa-client-types/lib/UnifiedInboxMailboxInfo";
import type TableView from "../../store/schema/TableView";
import { isSameMailboxInfo } from "owa-account-source-list-store";
import { isMultiAccountTable } from "../isMultiAccountTable";

export function areSelectedRowKeysFromSameMailboxInfoIfUnifiedInboxOrMultiAccountSearch(defaultMailboxInfo: MailboxInfo, tableView: TableView): boolean {
    if (isUnifiedInboxMailboxInfo(defaultMailboxInfo) || isMultiAccountTable(tableView)) {
        const rowkeys = [...tableView.selectedRowKeys.keys()];
        // if in virtual select all mode or no row keys selected, we can't determine mailbox info
        if (tableView.isInVirtualSelectAllMode || rowkeys.length < 1) {
            return false;
        }
        
        const mailboxInfos = rowkeys
            .map(rowKey => getMailboxInfo(rowKey, tableView))
            .filter(Boolean) as MailboxInfo[];
        
        // Check if all mailboxInfos are the same
        for (let i = 1; i < mailboxInfos.length; i++) {
            if (!isSameMailboxInfo(mailboxInfos[i - 1], mailboxInfos[i])) {
                return false;
            }
        }
    }
    
    return true;
}
